import Vue from 'vue';

import Content from '../models/content.model';
import KEYS from '../../values/keys';
import { ContentStore } from '@/app/private/my-content/models/content-store.model';
import { BUILDER_STATUS, BUILDER_SYNC_STATUS } from '@/courses/values/courses.values';

class ContentMutations {
  setViewType(state, viewType) {
    state.viewType = viewType;
  }

  setPageName(state, page) {
    state.pageName = page;
  }

  setContent(state, {content = [], page = '', type = '', totalPages = 0, builderContent = []}) {
    let contentItem = state[page][type];
    let contentList = contentItem.content;
    let contentBuilderMaps = new Map<number, any>();

    //When builderContent is not empty, builds the map to validate version of local item vs remote item
    //We need to check if the builderContent item is already in the contentList (by builderId) or it should be added.
    if(builderContent.length > 0) {
      let localContents = [];
      builderContent.forEach(local => {
        if (local.contentId)
          contentBuilderMaps.set(local.contentId, local);
        if (!contentList.some(remote => remote.builderId === local.builderId))  //Local builder is already in the contentList?
          localContents.push(local)
      });
      if(localContents.length > 0)  //Adds local contents to the beginning of the list
        contentList = localContents.concat(contentList);
    }

    content.forEach(c => {
      if(contentBuilderMaps.has(c.id)) {
        let content = contentBuilderMaps.get(c.id);
        if(c.version && content.version !== c.version && content.status != BUILDER_STATUS.PENDING) {
          content.status = BUILDER_STATUS.CONFLICT;
        }
        content.subtitle = c.categoryNames;
        content.authorsNames = getAuthorName(c);
        content.deleteRemote = true;
        content.deleteLocal = true;
      } else {
        contentList.push(new Content({
          ...c,
          subtitle: c.categoryNames,
          img: c.thumbnailMediumUrl,
          authorsNames: getAuthorName(c),
          status: c.status,
          syncStatus: BUILDER_SYNC_STATUS.READY_DOWNLOAD,
          builderId: c.builderId,
          deleteRemote: true
        }, KEYS.CONTEXT));
      }
    });
    contentItem.currentPage++;
    contentItem.content = contentList;
    contentItem.firstLoad = true;
    contentItem.hasMorePages = (contentItem.currentPage < totalPages);
    Vue.set(state[page], type, contentItem);

    function getAuthorName(c: any) {
      let authorString = '';
      if (c.type === KEYS.CONTENT_TYPE.BK) {
        c.authors.forEach((a, i) => {
          authorString += (i === (c.authors.length - 1)) ? ` ${a.fullName}` : `${a.fullName}, `;
        });
      } else {
        authorString = c.publisher.fullName;
      }
      return authorString;
    }
  }

  refreshContent(state, content) {
    state.subjects.courses.content = content;
  }

  removeContent(state, content) {
    state[state.pageName].courses.content = state[state.pageName].courses.content.filter(
      c => c.id != content.id
    );
  }
  
  setCoursesAlreadyLoaded(state, value){
    state.coursesAlreadyLoad = value;
  }

  setPage(state, { page, idCourse = -1}){
    if(idCourse == -1) {
      state.page = page;
    }else{
      let course = state.coursesWithHomeworks.find((course) => {
        return course.id == idCourse;
      });
      course.page = page;
      course.loadedFirstTime = false;
    }
  }

  initCourses(state) {
    state.subjects = new ContentStore();
    state.purchased = new ContentStore();
  }

  updateContentStatus(state, { page, contentId, status }: { page: string, contentId: number, status: any }) {
    const contentList: Content[] = state[page]?.courses?.content || [];
    const content = contentList.find(c => c.id === contentId);

    if (content) {
      content.status = status;
    }
  }

  setSingleContent(state, { page, content, status, type }: { page: string, content: any, status: any, type: any }) {
    let contentItem = state[page][type];
    const contentList: Content[] = state[page]?.courses?.content || [];
    const contentFound = contentList.find(c => c.id === content.contentId);

    if (contentFound) {
      content.status = status;
    } else {
      let authorString = content.publisher?.fullName;
      contentList.push(new Content({
        ...content,
        subtitle: content.categoryNames,
        img: content.thumbnailMediumUrl,
        authorsNames: authorString,
        status: status,
      }, KEYS.CONTEXT));

      Vue.set(state[page], type, contentItem);
    }
  }

  blockSubjectToShare(state, {courseId}) {
    state.subjects.courses.content = state.subjects.courses.content.map(el => {
      if (courseId === el.id) return { ...el, locked: true }
      else return el
    });
  }

  unblockSubjectToShare(state, {courseId}) {
    state.subjects.courses.content = state.subjects.courses.content.map(el => {
      if (courseId === el.id) return { ...el, locked: false }
      else return el
    });
  }

  /* Initial State */
  initState(state) {
    state.pageName = '';
    state.subjects = new ContentStore();
    state.purchased = new ContentStore();
    state.coursesAlreadyLoad = false;
  }
}

export default new ContentMutations();